import { duration } from "@mui/material"; 
import { useState } from "react";
import { Link } from "react-router-dom";


const ExpressCenterComponent = () => {
  const handleClose = () => setShow(false);
  const [setShow] = useState(false);
  return (
    <div className="flex flex-col justify-center items-center bg-[#f6f9fc]">
      <div className="px-10 flex flex-col justify-center items-center">
        <h1
          className="react-reveal font-bold text-center sm:text-4xl text-3xl -bottom-1 sm:pt-[4rem] pt-[40px] text-[#373737]"
        >
          TCS Express Centre
        </h1>
        <hr
          className="react-reveal hr"
          // style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 300ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-956696897109290-3;"
        />
        <p
          className="react-reveal text-sm text-center max-w-[55rem] mt-[1.5rem] mb-[1rem]"
          // style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 600ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-956696897109290-3;"
        >
          In 1983, with twelve Express Centres and twenty-five shipments is where it started for TCS. 
          Now with a network of more than 1,000 retail centres in the country, serving customers 24-hours a day, 
          Express operation is the bedrock of TCS products and services. Five different classes of TCS Express Centres, 
          including COCO, Franchised, Shop-in-Shop, Agents and IBRS, serve as a one-stop-shop for our customers.
        </p>
        <p className="react-reveal text-sm text-center max-w-[55rem]  mb-[2rem]">
        Facilitating walk-in customers at our Express Centres across Pakistan, we cater for the largest 
        customer base in the country, with an endless range of cost-effective solutions, from domestic 
        and international shipments of documents and parcels, to document attestation, visa dropbox, 
        branchless banking, fulfilment services and everything in-between.
        </p>
      </div>
      <div
        className="react-reveal"
        // style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 900ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-956696897109290-3;"
      >
        <a href="/become-Franchise">
          <button className="moreBtn mb-[3rem] transition-all duration-500 gradientbg">Become A Business Partner</button>
        </a>
      </div>
      <div className="relative">
        <img src="/Home/express-center-new.jpg" alt="" />
      </div>
    </div>
  );
};

export default ExpressCenterComponent;
